<template>
	<div id="sport-page">
		<content-view :color="color">
			<template slot="intro">
				<div class="center">
					<div class="text">
						<h1 v-collide="'fadeInLeft'">На пике формы</h1>
						<p v-collide="'fadeInUp'">
							Хочешь оказаться на пике своей формы? Чтобы ты мог, словно
							мощный автомобиль, мчаться по жизни к новым рекордам?
							В этом тебе поможет...
						</p>

						<div class="wrap">
							<img :src="getImg('intro-text-image.png')" v-collide="'fadeInUp'">
							<p v-collide="'fadeInRight'">
								Строгий, но справедливый тренер, который точно знает как
								достичь пика формы и остаться на нем. Он подготвил для тебя
								персональные программы по тренировкам на 4 месяца. Чтобы
								получить их - просто оставить свой мейл.
								Готов? Тогда, вперед!
							</p>
						</div>
					</div>
				</div>
			</template>
			<template slot="programs">
				<div id="program-1" :class="{'visible': visible.first}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 1</h2>
									<a v-if="!visible.first" class="button button-show" @click="visible.first = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.first" v-collide="'fadeInUp'">Спорт</h3>ы
								<p v-if="visible.first" v-collide="'fadeInLeft'">
									4 месяца — достаточный срок, чтобы достичь очень серьезной цели в беге. Особенно
									если вы только в начале пути, когда прогресс идет максимально быстро, но надо
									быть внимательным и осторожным, чтобы не навредить здоровью.
								</p>

							</div>
						</div>
						<div v-if="visible.first" class="program-blocks">
							<div class="program-block program-block-1" >
								<div class="row-with-picture">
									<div class="text" v-collide="'fadeInLeft'">
										<p>
											Итак, каких целей можно достичь за 4 месяца?
										</p>
										<p>
											Если вы бегали давно или вообще никогда не бегали,
											то за 4 месяца регулярных тренировок вы сможете
											подготовиться к полумарафону — дистанции в 21 км.
											Если у вас за плечами хороший беговой сезон, то можно
											замахнуться и на полный марафон — 42 км.
										</p>
										<p>
											После постановки главной цели — 21 километр, имеет
											смысл выработать план.
										</p>
									</div>
									<img :src="getImg('program-1-1.png')" v-collide="'fadeInRight'">
								</div>
							</div>

							<div class="program-block program-block-2">
								<div class="row-with-picture">
									<img :src="getImg('program-1-2.png')" v-collide="'fadeInLeft'">
									<div class="text" v-collide="'fadeInRight'">
										<h5>Подготовка</h5>
										<p>
											Разделим 4 месяца на 4 блока по 1 месяцу подготовки:
										</p>
										<ul>
											<li>
												<span class="number">1</span>
												<span>
													1-й месяц втягивающий и базовый — чтобы начать бегать, привыкнуть, дать организму осознать, что нагрузка стала постоянной.
												</span>
											</li>
											<li>
												<span class="number">2-3</span>
												<span>
													2-й и 3-й месяцы — так называемое “строительство”.
													Это тренировки, направленные на развитие -  различного рода интервалы и бег с переменным темпом. Они нужны
													для того, чтобы вывести вас на следующий уровень
													тренированности.
												</span>
											</li>
											<li>
												<span class="number">4</span>
												<span>
													4-й месяц — подводка к старту полумарафона.
												</span>
											</li>
										</ul>
									</div>
								</div>
							</div>

							<div class="program-block program-block-3">
								<div class="row-with-picture">
									<div class="text" v-collide="'fadeInLeft'">
										<p>
											Во всех этих этапах необходимы последовательность
											и постоянство. Сам полумарафон — это лишь награда
											за тренировки.
										</p>
										<p>
											Невозможно пробежать длинную дистанцию с наскока.
											Этим и хорош бег — он тренирует дисциплину и силу
											воли. Будут дни, когда вам совершенно не захочется
											выходить на пробежку. Учтите, что в такие моменты
											и закаляется характер.
										</p>
										<p>
											Запомните важное правило, особенно актуальное зимой - не бывает плохой погоды для пробежки, бывает
											неподходящая экипировка. От качества экипировки
											во многом зависит ваше удовольствие от бега. Поэтому
											не экономьте на ней.

										</p>
									</div>
									<img :src="getImg('program-1-3.png')" v-collide="'fadeInRight'">
								</div>
							</div>
							<div class="program-block program-block-4">
								<div class="row-with-picture">
									<div class="text" v-collide="'fadeInLeft'">
										<p>
											И, конечно, для начинающего бегуна очень важен принцип «публичного обещания».
										</p>

										<p>
											Что это означает? Чтобы невзначай не свернуть с пути,
											заранее обрубите все возможные пути отхода.
											Расскажите о своей цели как можно большему
											количеству людей. Напишите о ней в своих социальных
											сетях. В таком случае у вас будет постоянная мотивация
											бегать.
										</p>

										<p>
											Вы же не хотите выглядеть плохо в глазах ваших друзей? Удачи!
										</p>

										<a v-if="visible.first" @click="visible.first = false" class="button button-hide">
											<span>Скрыть</span>
										</a>
									</div>
									<img :src="getImg('program-1-4.png')" v-collide="'fadeInRight'">
								</div>
							</div>

						</div>
					</div>
					<Sides/>
				</div>

				<div id="program-2" :class="{'visible': visible.second}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 2</h2>
									<a v-collide="'fadeInUp'" v-if="!visible.second" class="button button-show" @click="visible.second = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.second" v-collide="'fadeInUp'">Спорт</h3>
								<div v-if="visible.second" v-collide="'fadeInUp'">
									<p>
										Уже прошел месяц с начала ваших тренировок. Надеюсь, что вы уже определились с целью, и вот несколько советов, как ее достичь.
									</p>
								</div>
							</div>
						</div>
						<div v-if="visible.second" class="program-blocks">
							<div  class="program-block program-block-1">
								<div class="row-with-picture" >
									<div v-collide="'fadeInLeft'" class="text">
										<h5 class="with-number">
											<span>Поддержка/партнер по тренировкам</span>
										</h5>
										<p>
											Вам нужна группа поддержки или партнер по тренировкам. В следующие три месяца будут моменты, когда вам захочется пропустить тренировку, но если у вас есть единомышленник, то идти к цели гораздо легче. Чтобы тренироваться одному, нужно обладать железной волей. Искренне рекомендую найти кого-то, с кем можно разделить тяготы и радость тренировок. Этот совет особенно актуален сейчас, когда к концу первого месяца ваша мотивация может несколько угаснуть.
										</p>
									</div>
									<img v-collide="'fadeInRight'" :src="getImg('program-2-1.png')" >
								</div>
							</div>
							<div class="program-block program-block-2">
								<div class="row-with-picture">
									<div v-collide="'fadeInLeft'" class="text">
										<h5 class="with-number"><span>Тренер или наставник</span></h5>
										<p>
											Уверен, что после месяца тренировок у вас возникло много вопросов — что делать, чего не делать и как правильно. Принцип простой — и он работает не только в спорте, но и в жизни: найдите наставника или профессионального тренера. Словом, человека с опытом, который уже набил шишки и своим советом и поддержкой не позволит этого сделать вам.
										</p>
									</div>
									<img v-collide="'fadeInRight'" :src="getImg('program-2-2.png')">
								</div>
							</div>
							<div class="program-block program-block-3">
								<div class="row-with-picture">
									<img v-collide="'fadeInLeft'" :src="getImg('program-2-3.png')">
									<div v-collide="'fadeInRight'" class="text">
										<h5 class="with-number"><span>Бег — это комплекс упражнений</span></h5>
										<p>
											Зачастую начинающие бегуны пренебрегают общей физической и силовой подготовкой, но к бегу нужно относиться, как к комплексу упражнений. Это не значит, что нужно срочно бежать в спортзал и тягать железо, но стоит обратить внимание как минимум на пресс и спину. Бег сам по себе недостаточно укрепляет мышцы, поэтому упражнения будут нелишними.
										</p>
									</div>
								</div>
							</div>
							<div  class="program-block program-block-4">
								<div class="row-with-picture">
									<div v-collide="'fadeInLeft'" class="text">
										<h5>Тренировки по пульсу</h5>
										<p>
											Придумайте метрику, которой вы будете измерять свой прогресс. В беге такой метрикой  может стать пульс. Для этого нужно приобрести пульсометр или ремень, который коннектится к телефону, чтобы вы всегда
											знали, с каким пульсом бежите. Если вы тренируетесь
											правильно, то ваш пульс будет снижаться.
										</p>
										<p>
											Успехов!
										</p>
									</div>
									<img v-collide="'fadeInRight'" :src="getImg('program-2-4.png')">
								</div>
							</div>
						</div>
						<a v-collide="'fadeInRight'"
						   @click="visible.second = false"
						   v-if="visible.second"
						   class="button button-hide">
							<span>Скрыть</span>
						</a>
					</div>


					<Sides/>
				</div>
			</template>


			<template slot="programs_bottom">
				<div id="program-3" :class="{'visible': visible.third}">
					<div class="center">
						<div class="program-header">
							<div   class="header">
								<h2 v-collide="'fadeInLeft'">Программа 3</h2>
								<a v-collide="'fadeInLeft'"  v-if="!visible.third" class="button button-show" @click="visible.third = true">
									<span>Узнать подробнее</span>
								</a>
							</div>
							<div v-if="visible.third" class="text"  v-collide="'fadeInLeft'" >
								<p>Привет, атлет!</p>
								<p>До целевого забега остается уже меньше половины
									времени. Если вы регулярно тренируетесь
									и не пропускаете тренировки — продолжайте,
									и все будет супер.</p>
								<p>Если же у вас не получалось системно тренироваться
									или серьезные части подготовки были пропущены
									по каким-то причинам, то не стоит отчаиваться.
									Еще есть возможность подготовиться.
								</p>
							</div>
						</div>
						<div v-if="visible.third" class="program-blocks">
							<div  class="program-block program-block-1">
								<div class="text"  v-collide="'fadeInRight'">
									<h5>Вот несколько советов о том, на что обратить внимание:</h5>
									<p>
										Постоянство тренировок. Это самая существенная сила,
										которая приблизит вас к цели — финишу на забеге.
										Поставьте перед собой цель на ближайший месяц:
										как минимум три тренировки в неделю, а лучше —
										четыре. И, собрав всю волю в кулак, сдержите свое слово.
									</p>
								</div>
								<img v-if="visible.third" :src="getImg('program-3-1.png')" v-collide="'fadeInLeft'">
							</div>
							<div class="program-block program-block-2" >
								<div class="text"  v-collide="'fadeInRight'">
									<p>
										Длительная тренировка по выходным. Обязательно
										добавьте длительную пробежку в легком темпе
										по выходным. Это самая приятная тренировка.
										Представьте: вы встаете в воскресенье в 8 утра,
										в 8.30 вы уже в парке или на набережной, в 8.31
										начинаете забег. Город еще спит, а вы уже тренируетесь.
										В 9.30 с невероятным чувством удовлетворения
										вы возвращаетесь домой, где, возможно, еще даже
										никто не проснулся. Обязательно делайте такую
										тренировку каждую неделю. Начните с 40–60 минут
										очень легкого бега и добавляйте каждую неделю
										по 10 минут.
									</p>
								</div>
							</div>
							<div class="program-block program-block-3" >
								<div class="row-with-picture">
									<img v-if="visible.third" :src="getImg('program-3-2.png')" v-collide="'fadeInLeft'">
									<div class="text"  v-collide="'fadeInRight'">
										<p>
											Интервальная тренировка. Добавьте в будний день —
											лучше в среду или четверг — интервальную тренировку. Начните с коротких интервалов (1–2 минуты) и спокойной трусцы (3–5 минут) между ними. Каждую неделю можете прибавлять по 1 минуте к интервалу. Такая тренировка
											дает очень серьезный прогресс.
										</p>
									</div>
								</div>
							</div>
							<div class="program-block program-block-4" >
								<div class="row-with-picture">
									<div class="text" v-collide="'fadeInLeft'">
										<p>
											ОФП. Не забывайте делать упражнения на пресс
											и спину. 10 минут в день таких упражнений на коврике дома дадут вам невероятный прогресс и легкость на целевом забеге!
										</p>
										<h5>Удачи!</h5>
										<a @click="visible.third = false" v-if="visible.third" class="button button-hide">
											<span>Скрыть</span>
										</a>
									</div>
									<img v-if="visible.third" :src="getImg('program-3-3.png')" v-collide="'fadeInRight'">
								</div>
							</div>
						</div>
					</div>
				</div>
				<Subscribe/>
				<Sides/>
			</template>
			<template slot="product_picture">
				<img class="product-picture" src="assets/pictures/sport/product-picture.png">
			</template>
			<template slot="product">
				Новый KIA Sportage станет твоим проводником в мир, полный
				открытий и приключений, ведь это автомобиль - на пике формы!
				Новый двигатель 2.4 GDI (184 л.с.)  открывает новый уровень
				динамики и эффективности KIA Sportagе. Благодаря сочетанию
				мощности и топливной экономичности ты сможешь преодолевать
				большее расстояние, не отказывая себе в наслаждении динамикой
				и управляемостью при любых дорожных и погодных условиях.
			</template>
		</content-view>
	</div>
</template>


<script>
    import ContentView from '@/components/ContentV2'
    import Sides from '@/components/Sides'
    import Subscribe from '@/components/Subscribe'
    import { colors } from '@/data/pages'
    import LINKS from '@/data/links';

    export default {
        name: 'Sport',
        components: {
            ContentView,
            Sides,
            Subscribe
        },
        data() {
            return {
                visible: {
                    first: false,
                    second: false,
                    third: false
                },
                color: colors[this.$route.name],
            }
        },
        computed: {
            learnmoreLink() {
                return LINKS[this.route]
            },
        },
        methods: {

            getImg(name) {
                return require(`@/assets/images/${this.$route.name}/${name}`)
            },
        }
    }
</script>

<style lang="less">
	@import '../styles/variables';

	#sport-page {

		#program-1 {
			position: relative;
			z-index: 1;
			.program-header {
				h2 {
					display: block;
					margin-bottom: 0;
				}
				h3 {
					margin-top: 10px;
				}
				img {
					position: relative;
					width: calc(~'100% + 40px');
					z-index: 2;
					display: block;
					margin-top: 30px;
					@media (max-width: 959px) {
						left: -20px;
					}

					@media (min-width: 960px) {
						right: 0;
						width: 100%;
						max-width: 50%;
						margin-left: auto;
						left: 5%;
					}
				}

				.text {
					margin-top: 70px;
					margin-bottom: 30px;
					z-index: 3;
					position: relative;
					@media (min-width: 960px) {
						left: 10%;
						max-width: 70%;
						margin-bottom: 0;
					}
					&:before {
						content: "";
						display: block;
						position: absolute;
						right: -120px;
						top: -10px;
						width: 70px;
						height: 110px;
						background: url('../assets/images/sport/double-arrows-1.png') no-repeat center center;
						background-size: contain;
					}
					&:after {
						content: "";
						display: block;
						position: absolute;
						left: 25%;
						top: -220px;
						width: 50%;
						height: 960px;
						background: url('../assets/images/sport/dots-1.png') no-repeat center center;
						background-size: contain;
					}
				}

			}

			.sides {
				bottom: 0;
			}
			h5 {
				text-transform: uppercase;
				font-size: 24px;
				font-family: @font-bold;
			}
			@media (min-width: 960px) {
				.program-block-1 {
					margin-top: 60px;
					margin-left: 10%;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						padding-right: 10%;
						max-width: 40%;
					}
					img {
						max-width: 50%;
					}
				}

				.program-block-2 {
					.row-with-picture {
						align-items: flex-end;
					}
					img {
						max-width: 60%;
						margin-top: -120px;
						margin-left: -20%;
					}
					.text {
						position: relative;
						top: -30px;
						margin-left: 15%;
						max-width: 40%;

						p {
							position: relative;
							z-index: 1;
						}
						li {
							position: relative;
							margin-bottom: 60px;
							span {
								position: relative;
								z-index: 1;
							}
							.number {
								font-family: @font-bold;
								display: block;
								font-size: 100px;
								color: #000;
								position: absolute;
								z-index: 0;
								top: -80px;
								left: 0;
								width: 100%;
								text-align: center;
							}

						}
					}
				}
				.program-block-3 {
					margin-left: 5%;
					max-width: 95%;
					.text {
						margin-right: 10%;
					}
					img {
						max-width: 60%;
					}
				}
				.program-block-4 {
					max-width: 95%;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						max-width: 40%;
						margin-right: 5%;
						position: relative;
						top: 120px;
					}
					img {
						max-width: 55%;
					}
				}


			}

			.button {
				margin-top: 60px;
				&:after {
					display: none;
				}
			}
			.header {
				width: auto;
				display: inline-block;
				text-align: center;
				position: relative;

				&:after {
					content: "";
					display: block;
					width: 230px;
					height: 65px;
					background: #c21734;
					position: absolute;
					bottom: -10px;
					right: -60px;
				}
			}
			.button-show {
				left: 0;
				margin: 0 auto;
				display: inline-block;
			}
		}
		#program-2 {
			position: relative;
			z-index: 0;
			margin-bottom: 60px;
			@media (min-width: 960px) {
				margin-bottom: 0;
			}
			&:before {
				content: "";
				display: block;
				position: absolute;
				left: 20%;
				top: -320px;
				width: 60%;
				height: 920px;
				background: url('../assets/images/dots-1.png') no-repeat center center;
				background-size: contain;
			}
			&.visible:before {
				display: none;
			}

			@media (min-width: 960px) {
				margin-top: -75px;
			}
			&.visible {
				margin: 0;
			}
			.program-header {

				.text {
					margin-bottom: 30px;
					z-index: 3;
					@media (min-width: 960px) {
						margin-left: 5%;
					}
					p {
						@media (min-width: 960px) {
							max-width: 70%;
							margin-bottom: 16px;
						}
					}
				}

				h2 {
					display: block;
				}

				p {
					position: relative;
					font-family: @font-light;
					font-size: 16px;
					z-index: 1;
				}
			}
			img {
				display: block;
				margin-top: 60px;
				width: 100%;
			}
			.header {
				width: auto;
				display: inline-block;
				text-align: center;
				white-space: nowrap;
				@media (min-width: 960px) {
					margin-left: 60%;
				}
			}
			.button {
				margin-top: 30px;
				margin-bottom: 30px;
				&:after {
					background: #c21734;
					left: -120px;
					transform: skew(-45deg);
				}
				@media (min-width: 960px) {
					margin-top: 60px;
					margin-bottom: 120px;
				}
			}
			.program-block {
				.text {
					h5 {
						font-size: 20px;
						font-family: @font-bold;
					}
					.with-number {
						position: relative;
						display: inline-block;
						span {
							position: relative;
							z-index: 1;
						}
					}
					.with-number:after {
						font-family: @font-bold;
						display: block;
						font-size: 100px;
						color: #000;
						position: absolute;
						z-index: 0;
						top: -80px;
						left: 0;
						width: 100%;
						text-align: center;
					}
				}
			}
			.program-block-1 .with-number:after {
				content: "1";
			}
			.program-block-2 .with-number:after {
				content: "2";
			}
			.program-block-3 .with-number:after {
				content: "3";
			}
			@media (min-width: 960px) {

				.program-block-1 {
					margin-left: 5%;
					max-width: 95%;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						position: relative;
						top: 120px;
						max-width: 50%;
					}
					img {
						position: relative;
						max-width: 60%;
						left: 15%;
					}
				}
				.program-block-2 {
					.row-with-picture {
						align-items: flex-end;
					}
					img {
						width: 70%;
						position: relative;
						margin-left: -20%;
					}
					.text {
						margin-left: 5%;
						position: relative;
						top: -60px;
					}
				}
				.program-block-3 {
					.row-with-picture {
						align-items: flex-end;
					}
					img {
						margin: 0;
						width: 50%;
						position: relative;
					}
					.text {
						margin-left: 10%;
						position: relative;
						top: 60px;
					}
				}
				.program-block-4 {
					margin-bottom: 320px;
					max-width: 90%;
					img {
						margin: 0;
						margin-left: auto;
						width: 60%;
						position: relative;
					}
					.text {
						position: relative;
						top: 50px;
					}
				}
				.button {
					position: absolute;
					right: 12.5%;
					bottom: 180px;
					margin-top: 0;
					margin-bottom: 0;
				}
				.button-show {
					position: relative;
					display: inline-block;
					bottom: 0;
					right: auto;
					margin: 0 auto;
					margin-bottom: 120px;
				}
			}
			@media (max-width: 959px) {
				.program-block-2 {
					.text {
						margin-top: 60px;
					}
  				}
				.program-block-3 {
					.text {
						margin-top: 60px;
					}
				}
				.button {
					margin-bottom: 120px;
				}
			}
		}

		#banner {
			&:before {
				background: url('../assets/images/lines-black.png') no-repeat center center;
				background-size: contain;
			}
			&:after {
				background: url('../assets/images/sport/double-arrows-2.png') no-repeat center center;
				background-size: contain;
				left: 60%;
			}
		}

		#program-3 {
			h5 {
				font-size: 20px;
				font-family: @font-bold;
			}
			.program-header {
				position: relative;
				&:before {
					content: "";
					display: block;
					position: absolute;
					left: -30px;
					top: 110px;
					width: 220px;
					height: 60px;
					background: #C21734;
				}

				img {
					position: relative;
					width: calc(~'100% + 40px');
					z-index: 2;
					display: block;
					margin-top: 30px;
					@media (max-width: 959px) {
						left: -20px;
						width: 100%;
					}

					@media (min-width: 960px) {
						margin-left: auto;
						width: 100%;
						max-width: 60%;
						left: 20%;
					}
				}

				.text {
					margin-top: 65px;
					p {
						margin-bottom: 16px;
					}
					@media (min-width: 960px) {
						left: 5%;
						max-width: 45%;
					}
				}

				.header {
					margin-top: 30px;
					font-size: 16px;
					position: relative;
					font-family: @font-light;

					@media (min-width: 960px) {
						text-align: center;
						left: 5%;
						width: 95%;
						max-width: 40%;
					}
				}
			}

			.button-show {
				display: inline-block;
				&:after {
					background: #c21734;
				}
			}
			.program-block {
				.text {
					p {
						position: relative;
						z-index: 1;
					}
					h5 {
						position: relative;
						z-index: 1;
					}
				}
				.text:before {
					content: "";
					font-family: @font-bold;
					display: block;
					font-size: 100px;
					color: #000;
					position: absolute;
					z-index: 0;
					top: -60px;
					left: 40px;
				}
			}
			.program-block-1 {
				.text:before {
					content: "1";
				}
			}
			.program-block-2 {
				.text:before {
					left: 120px;
					top: -80px;
					content: "2";
				}
			}
			.program-block-3 {
				.text:before {
					content: "3";
				}
			}
			.program-block-4 {
				.button:after {
					background: #C21734;
				}
				.text:before {
					content: "4";
				}
			}
			h5 {
				margin-top: 60px;
			}
			.text {
				position: relative;
			}
			@media (min-width: 960px) {
				.program-block-1 {
					position: relative;
					.text {
						position: relative;
						margin-left: auto;
						margin-right: 5%;
						max-width: 50%;
						margin-top: 60px;
						margin-bottom: 0;
					}
					img {
						position: relative;
						top: -60px;
						max-width: 90%;
						margin-left: 5%;
					}
				}


				.program-block-2 {
					margin-top: 60px;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						margin-left: auto;
						max-width: 40%;
						position: relative;
						top: -25px;
					}
					img {
						width: 60%;
						margin-left: -20%;
					}
				}
				.program-block-3 {
					margin-top: -120px;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						margin-left: auto;
						max-width: 50%;
						position: relative;
						top: -25px;
					}
					img {
						width: 60%;
						margin-left: -20%;
					}

				}
				.program-block-4 {
					@media (min-width: 960px) {
						margin-bottom: 120px;
					}
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						max-width: 45%;
						position: relative;
						top: 45px;

					}
					img {
						width: 65%;
						position: relative;
						left: 10%;
					}
					.button {
						margin-top: 30px;
					}
				}

			}
			@media (max-width: 959px) {
				img {
					max-width: 100%;
				}
			}

		}
		.programs-bottom-subscribe {
			.button {
				&:after {
					display: none;
				}
			}
		}
		.programs-bottom-forms {
			&:before {
				content: "";
				display: block;
				position: absolute;
				left: 10%;
				top: -10px;
				width: 180px;
				height: 180px;
				background: url('../assets/images/lines-black.png') no-repeat center center;
				background-size: contain;
			}
			&:after {
				content: "";
				display: block;
				position: absolute;
				right: 10%;
				top: 130px;
				width: 110px;
				height: 110px;
				background: url('../assets/images/sport/double-arrows-1.png') no-repeat center center;
				background-size: contain;
			}
			.button {
				&:after {
					background: #c21734;
					width: 220px;
					bottom: auto;
					top: -30px;
					left: -65px;
				}
			}
			@media (min-width: 960px) {
				.inner {
					top: 0;
					margin-top: 0;
					margin-bottom: 160px;
					width: 40%;
					right: 0;
				}
			}
			.inner {

				h2 {
					position: relative;
				}
				@media (max-width: 959px) {
					position: relative;
					top: -60px;
				}
			}
		}
		#product h2:after {
			color: #000;
		}
	}
</style>
